import { theme } from "../../utils/theme";

export const styles = {
  logo: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: 52,
    width: 178,
  },
  logoContainer: {
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
  },
  logoIcon: {
    display: { md: "none", sm: "block" },
    height: 36,
    width: 36,
  },
  margin: {
    display: "flex",
    margin: 1,
  },
};
